export const unreadPivotAriaLabel = "Ss8FX";
export default {unreadPivotAriaLabel};